import { render, staticRenderFns } from "./heatmap_event.vue?vue&type=template&id=473d0b13&lang=pug&"
import script from "./heatmap_event.vue?vue&type=script&lang=js&"
export * from "./heatmap_event.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports